import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { actions } from 'stores/invoiceManagement/actions/tradevanCreate/personalCarrier';
import { mobileBarcodeRule } from '../../validateRules';
import { submitKeySelector } from '../../selectors/main';
import { Field, FormInput } from '../../components';
import PARENT_E2E_PREFIX from './e2ePrefix';

const E2E_PREFIX = `${PARENT_E2E_PREFIX}-mobile-barcode`;

const MobileBarcode = ({ carrierValue }) => {
  const { t } = useTranslation();
  const submitKey = useSelector(submitKeySelector);
  const dispatch = useDispatch();
  const handleChange = useCallback(
    ({ target: { value } }) => {
      dispatch(actions.setValue(value));
    },
    [dispatch],
  );
  return (
    <Field title={`${t('invoiceManagement:Mobile Barcode')}*`}>
      <FormInput
        block
        value={carrierValue}
        onChange={handleChange}
        e2eInputId={`${E2E_PREFIX}-input`}
        e2eMessagesId={`${E2E_PREFIX}-errors`}
        trimStart
        trimEnd
        rule={mobileBarcodeRule}
        fieldName={t('invoiceManagement:Mobile Barcode')}
        validateKey={submitKey}
      />
    </Field>
  );
};

export default MobileBarcode;
